export default __webpack_public_path__ + "static/media/1125.5df445fd.png";